// material-ui
import { Button, Dialog, IconButton, Link, Stack, Typography } from "@mui/material";
import { Call, DirectInbox, Instagram, Whatsapp } from "iconsax-react";

import AddFeedback from "./AddFeedback";
import AnimateButton from "components/@extended/AnimateButton";
// project-imports
import MainCard from "components/MainCard";
import { PopupTransition } from "components/@extended/Transitions";
// assets
// import avatar from "assets/images/users/customer-support-1.png";
import { useState } from "react";

// ==============================|| DRAWER CONTENT - NAV CARD ||============================== //

const NavCard = ({ token, clientid }) => {
  const [add, setAdd] = useState(false);

  const handleAdd = () => {
    setAdd((prevAdd) => !prevAdd);
  };
  return (
    <MainCard sx={{ bgcolor: "#115D5B", color: "white", m: 3 }}>
      <Stack alignItems="center" spacing={2.5}>
        {/* <CardMedia component="img" image={avatar} /> */}
        <Stack alignItems="start">
          <Typography variant="h5">Need Support?</Typography>

          <Stack direction="row" alignItems="center" spacing={2} mt={2}>
            <Call size={15} />
            <Typography variant="h6">
              <a href={`tel: 0552809558`} rel="noreferrer" target="_blank" style={{ textDecoration: "none", color: "white" }}>
                055 280 9558
              </a>{" "}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Call size={15} />
            <Typography variant="h6">
              <a href={`tel: 0553019529`} rel="noreferrer" target="_blank" style={{ textDecoration: "none", color: "white" }}>
                055 301 9529
              </a>{" "}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" spacing={2}>
            <DirectInbox size={15} />
            <Typography variant="h6" sx={{ color: "white" }} component={Link} href="mailto:support@wigal.com.gh" target="_blank">
              support@wigal.com.gh
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" mt={2}>
            <IconButton sx={{ color: "white" }} onClick={() => window.open("https://wa.me/233552809558", "_blank")}>
              <Whatsapp size={15} />
            </IconButton>
            <IconButton
              sx={{ color: "white" }}
              onClick={() => window.open("https://www.instagram.com/wigalgh?igsh=cWk5ajR6bHp2bTVz", "_blank")}
            >
              <Instagram size={15} />
            </IconButton>
            {/* <IconButton color="success" onClick={() => window.open("https://wa.me/233552809558", "_blank")}>
              <Faceb size={15} />
            </IconButton> */}
          </Stack>
        </Stack>
        <Stack direction="column" spacing={2}>
          <AnimateButton>
            <Button
              fullWidth
              variant="shadow"
              size="small"
              component={Link}
              href="https://support.wigal.com.gh/"
              target="_blank"
              sx={{ color: "white", bgcolor: "#000000" }}
            >
              Get Support
            </Button>
          </AnimateButton>
          <AnimateButton>
            <Button fullWidth variant="shadow" size="small" onClick={handleAdd}>
              Send Feedback
            </Button>
          </AnimateButton>
        </Stack>
      </Stack>
      <Dialog
        maxWidth="xs"
        fullWidth
        TransitionComponent={PopupTransition}
        keepMounted
        onClose={handleAdd}
        open={add}
        sx={{ "& .MuiDialog-paper": { p: 0 }, transition: "transform 225ms" }}
        aria-describedby="alert-dialog-slide-description"
      >
        <AddFeedback onCancel={handleAdd} clientid={clientid} token={token} />
      </Dialog>
    </MainCard>
  );
};

export default NavCard;
